//
// NAV
//

var fn_navigation_rwd = function () {
  jQuery.fx.off = true

  // MOBILE
  var fn_close_submenu = function () {

    // Hidding submenus and adjusting aria expanded flag to false
    $('#nav-primary .dropdown-submenu .nav-list.list-unstyled').hide()
    $('#nav-primary .dropdown-submenu a.dropdown-submenu__ttl').attr('aria-expanded', 'false')
  }
  var fn_navigation_mobile = function () {
    //

    // Removing BS Dropdown from desktop in case of switch between Desktop<>Mobile
    $('#nav-primary > li.dropdown > a').dropdown('dispose').removeAttr('data-toggle')
    // Hidding submenus and adjusting aria expanded flag to false
    fn_close_submenu();

    // NAV L2 + L3 Toggle + Focus on 1st link @uncollapsing
    $('#navbarprimary').on('shown.bs.collapse', function () {
      //
      // Setting first link as active
      $(this).find('#nav-primary .nav-section-1 .dropdown-toggle').focus()

      // Hidding submenus and adjusting aria expanded flag to false
      // $('#nav-primary .dropdown-submenu .nav-list.list-unstyled').hide()
      // $('#nav-primary .dropdown-submenu a.dropdown-submenu__ttl').attr('aria-expanded', 'false')

    //
    })

    // > Submenus toggler below
    $('#nav-primary .dropdown-submenu a.dropdown-submenu__ttl').on('click', function (e) {
      e.preventDefault()

      // toggling aria expanded
      var menuItem = $(this)
      if (menuItem.attr('aria-expanded') === 'true') {
        $(this).attr('aria-expanded', 'false')
      } else {
        $(this).attr('aria-expanded', 'true')
      }

      var navTarget = $(this).parent().find('.nav-list.list-unstyled')

      $(this).closest('li').find('.dropdown-submenu.show .nav-list.list-unstyled').not(navTarget).hide('', function () {
        $(this).parent().removeClass('show')
      })
      $(this).next('.dropdown-submenu .nav-list.list-unstyled').toggle('', function () {
        $(this).parent().toggleClass('show')
      })
    //
    })

    // > Main links
    $('#nav-primary > li > a').on('click', function (e) {
      var target = $(this).attr('aria-controls')
      if (!$(this).attr('aria-controls')) {
        return
      }

      // toggling aria expanded
      var mainMenuItem = $(this)
      if (mainMenuItem.attr('aria-expanded') === 'true') {
        $(this).attr('aria-expanded', 'false')
      } else {
        $(this).attr('aria-expanded', 'true')
      }

      e.preventDefault()

      $('.rwd-mobile #nav-primary > li > a[aria-controls]').not($(this)).each(function () {
        var target = $(this).attr('aria-controls')
        $('#' + target).hide('', function () {
          $(this).parent().removeClass('show')
        })
      })

      $('#' + target).toggle('', function () {
        $(this).parent()[$(this).is(':visible') ? 'addClass' : 'removeClass']('show')
      })
    })
  //
  }

  // DESKTOP
  var fn_navigation_desktop = function () {
    //
    // > Handling clicks on BS4 Toggle inside nested Links within MegaNav
    $(document).on('click', '.rwd-desktop #nav-primary .dropdown-menu', function (e) {
      e.stopPropagation()
    })

    $('.rwd-desktop #nav-primary > li.dropdown > a').attr('data-toggle', 'dropdown')
    $('.rwd-desktop #nav-primary > li.dropdown > a').dropdown()

    // Animation main megamenu @opening + Hiding submenus
    $('.rwd-desktop #nav-primary > li.dropdown').on('show.bs.dropdown', function () {
      //
      var menu = $(this).find('.dropdown-menu > div')
      menu.addClass('animated-short fadeInDownMenu')
      setTimeout(function (menu) {
        menu.removeClass('animated-short fadeInDownMenu')
      }, 700, menu)

      // Hidding submenus
      $('#nav-primary .dropdown-submenu .nav-list.list-unstyled').hide()
    })

    // > Submenus toggler below
    $('.rwd-desktop #nav-primary .dropdown-submenu a.dropdown-submenu__ttl').on('click', function (e) {
      e.preventDefault()

      // > Hiding all submenus
      $('.dropdown-menu__nav-sub .dropdown-submenu').removeClass('show')
      $('.dropdown-menu__nav-sub .dropdown-submenu').find('.nav-list.list-unstyled').hide()

      // toggling aria expanded
      var menuItem = $(this)
      if (menuItem.attr('aria-expanded') === 'true') {
        $(this).attr('aria-expanded', 'false')
      } else {
        $(this).attr('aria-expanded', 'true')
      }

      // > Displaying current link submenu 
      $(this).next('.dropdown-submenu .nav-list.list-unstyled').toggle('', function () {
        $(this).parent().toggleClass('show')
      })
    })
  //
  }



  if (Modernizr.mq('all and (max-width: 1199px)')) {
    // Hidding submenus and adjusting aria expanded flag to false
    fn_navigation_mobile()
    // console.log('fn mobile init')
  }else {
    fn_navigation_desktop()
    // console.log('fn desktop init')
  }

  $(window).on('load, resize', function () {
    if (Modernizr.mq('all and (max-width: 1199px)')) {
      // Hidding submenus and adjusting aria expanded flag to false
      fn_navigation_mobile()
      // console.log('fn mobile RE-init')
    }else {
      fn_navigation_desktop()
      // console.log('fn desktop RE-init')
    }
  })


}
